<template>
  <div>
    <div :class="['op--modal-container', {hide: !show}]">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="content-box">
  
            <div class="rt-msg">
              Great Move, Your Round trip fare for Flight From
              <b>
                {{ location.pickup.code }} - {{ location.dropoff.code }}
                <span v-if="currency.code === 'USD'">${{ parseFloat(totalPrice.toFixed(2)) }}</span>
                <span v-else>{{ applyCurrency(totalPrice) }}</span>
              </b>
            </div>

            <div class="field-row d-flex flex-column btn-box">
              <a @click="proceed" class="op-btn btn-block btn-md btn-success search-submit">
                Proceed for Booking
              </a>
              <a @click="show = false" class="op-btn btn-block btn-md">
                I change my mind
              </a>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xcurrency from '@/modules/api/currency'

export default {
  name: 'confirm-rt-modal',
  data () {
    return {
      location: {
        pickup: {},
        dropoff: {}
      }
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    selected () { return this.booking.selected },
    rtConfirm () { return this.booking.rtConfirm },
    show: {
      get () { return this.rtConfirm.show },
      set (x) { this.$store.commit('booking/setRtConfirmData', {show: x}) }
    },
    totalPrice () {
      let total = 0
      if (Object.keys(this.selected.leg1).length) total += this.selected.leg1.payment.totalWithMarkUp
      if (this.filters.departure.isReturning && Object.keys(this.selected.leg2).length) total += this.selected.leg2.payment.totalWithMarkUp
      return total
    },
    other () { return this.$store.state.other },
    currency () { return this.other.currency }
  },
  methods: {
    applyCurrency (x, useSymbol = true) {
      x = x.toString().replace(/[',']/g, '')
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) return parseFloat(x.toFixed(2))

      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    proceed () {
      this.show = false
      this.$store.commit('booking/setRtConfirmData', {activate: true})
    }
  },
  watch: {
    show (val) {
      if (val) {
        if (this.other.widgetTab === 'flight') {
          this.location = {
            pickup: this.booking.locations.pickupAirport,
            dropoff: this.booking.locations.dropoffAirport
          }
          return
        }
        this.location = {
          pickup: this.booking.locations.flight.pickup,
          dropoff: this.booking.locations.flight.dropoff
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.content-box{
  background-color: #fafafa;
  max-width: 430px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  padding: 20px 30px;

  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

.field-row{
  gap: 20px;
  margin-bottom: 20px;

  &.btn-box{
    gap: 10px;
    margin-bottom: 0;
  }
}
.rt-msg{
  line-height: 1.5;
  margin-bottom: 30px;
  letter-spacing: .4px;

  b{
    font-size: 21px;
    display: block;
    text-align: center;
    margin-top: 15px;
  }
  span{
    display: inline-block;
    margin-right: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// confirm-rt-modal.vue?4cca273e